import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import loadScript from 'shared-utils/src/loadScript';
import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';

import Gear from 'shared-vectors/icons/Gear';
import { Icon } from 'shared-vectors';

import GOOGLE_ACCOUNTS_LIB from 'shared-constants/src/googleOneTapLib';
import myCasaMenuLinks from 'shared-constants/src/header_footer/myCasaMenuLinks';

import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

const propTypes = {
  toggleMenu: PropTypes.func,
  isOpen: PropTypes.bool,
  user: PropTypes.instanceOf(Object).isRequired,
  logOut: PropTypes.func.isRequired,
  portalDomain: PropTypes.string.isRequired,
  myCasaDomain: PropTypes.string.isRequired,
  accountDomain: PropTypes.string.isRequired,
  fromPortal: PropTypes.bool,
};
const defaultProps = {
  toggleMenu: () => {},
  isOpen: false,
  fromPortal: false
};

const MyCasaMenu = ({
  toggleMenu,
  isOpen,
  user,
  logOut,
  portalDomain,
  myCasaDomain,
  accountDomain,
  authBasePrefix,
  fromPortal,
}) => {

  const cls = useStyles();
  const menuCls = makeClassName([
    cls[mainCls],
    isOpen && cls[`${mainCls}--opn`],
  ]);
  const headCls = makeClassName([
    cls[`${mainCls}__head`],
    'pr--m',
    'pl--m',
    'tp-s--s',
    'tp-w--m',
    'c-txt--f2',
  ]);
  const usrCls = makeClassName([
    cls[`${mainCls}__usr`],
    'pr--m',
    'pl--m',
    'tp-s--xs',
    'tp-w--m',
    'c-txt--f2',
  ]);
  const usrNameCls = makeClassName([
    cls[`${mainCls}__usr--name`],
    'tp-s--m',
    'tp-w--l',
    'c-txt--secondary',
  ]);
  const linkLstCls = makeClassName([
    cls[`${mainCls}__linkLst`],
    'mr--m',
    'ml--m',
    'pt--m',
    'pb--xs',
    'bb--s',
    'tp-w--m',
  ]);
  const linkLstDtCls = makeClassName([
    cls[`${mainCls}__linkLst--dt`],
    'mb--s',
    'c-txt--f3',
    'tp--up',
  ]);
  const linkLstACls = makeClassName([
    cls[`${mainCls}__linkLst--a`],
    'tp-s--s',
    'c-txt--secondary',    
  ]);
  const ovrlCls = makeClassName([
    cls[`${mainCls}__ovrl`],
    isOpen && cls[`${mainCls}__ovrl--opn`],
  ]);
  const safeDomain = (x) => { if (x) { return x.slice(-1) !== '/' ? `${x}/` : x; } else { return ''; }};

  const [hasGAccountsLib, setHasGAccountsLib] = useState(false);

  useEffect(async () => {
    if (isOpen) {
      const script = document.querySelector(`script[src="${GOOGLE_ACCOUNTS_LIB}"]`);
      if (!script) {
        const a = await loadScript(GOOGLE_ACCOUNTS_LIB);
        setHasGAccountsLib(a.type === 'load' && window.google?.accounts);
      } else if (window.google?.accounts) {
        setHasGAccountsLib(true);
      } else {
        console.log(':: script già caricato ma window.google.accounts assente ::');
      }
    }
  }, [isOpen]);

  const doLogOut = () => {
    if (hasGAccountsLib) {
      google.accounts.id.disableAutoSelect();
    }
    logOut();
  };

  const trackOnClick = () => trackGTMEvents({
    category: 'Interaction',
    action: 'PublishAdStart',
    position: 'ButtonProfileMenu',
  });

  return (
    <>
      <div className={menuCls}>
        <div className={headCls}>
          <span className="c-txt--primary">My</span>Casa
          <button
            type="button"
            className={`${cls[`${mainCls}__head--btn`]} tp-w--m c-txt-secondary`}
            title="Effettua il logout"
            aria-label="Effettua il logout"
            onClick={doLogOut}
          >
            Esci
          </button>
        </div>
        <div className={cls[`${mainCls}__body`]}>
          <div className={usrCls} >
            <p data-clarity-mask="True" className={usrNameCls}>{user.displayName}</p>
            <p data-clarity-mask="True">{user.username}</p>
            {
              user.phone
                && (
                  <p data-clarity-mask="True" >{user.phone}</p>
                )
            }
            <a href={`${accountDomain}${authBasePrefix}/profilo`} title="" className={[`${mainCls}__usr--gear`]}>
              <Icon name={Gear} width="20px" height="20px" />
            </a>
          </div>
          {
            myCasaMenuLinks.map(
              (section) => {
                if(!user.isPublisherBlacklisted || !section.hideIfBlacklisted) {
                  return (
                    <dl className={linkLstCls} key={section.title.txt}>
                      <dt className={`${linkLstDtCls}${section.title.isNew ? ` ${cls[`${mainCls}__linkLst--dt--new`]}` : ''}`}>{section.title.txt}</dt>
                      {
                        section.links.map(
                          (link) => {
                            const prefix = section.hasAuthPrefix ? `${authBasePrefix}` : '';
                            let url = `${myCasaDomain}${prefix}${link.url}`;

                            const action = link.url === '/pubblica/nuovo'
                              ? trackOnClick
                              : null;

                            if (section.domain === 'portal') {
                              url = fromPortal
                                ? link.url
                                : `${portalDomain}${link.url}`;
                            }
                            return (
                              <dd key={link.url}>
                                <a href={url} className={linkLstACls} title={link.txt} onClick={action}>{link.txt}</a>
                              </dd>
                            );
                          },
                        )
                      }
                    </dl>
                  )
                }
              }
            )
          }
        </div>
      </div>
      <div className={ovrlCls} onClick={toggleMenu} />
    </>
  );
};
MyCasaMenu.propTypes = propTypes;
MyCasaMenu.defaultProps = defaultProps;
export default MyCasaMenu;
